import React from "react";
import _ from "lodash";
import Button from "Components/button/Button";
import QboxmailApi from "../../../qboxmailApi";
import DomainSelect from "Components/domainSelect/DomainSelect";
import TranslatedString from "Components/TranslatedString";
import PropTypes from "prop-types";
import FolderMapper from "Components/folderMapper/FolderMapper";

import WarningBanner from "Components/warningBanner/WarningBanner";

import t from "Utils/translation";
import cx from "classnames";
import s from "./emailsAddForm.scss";

const ContextTypes = {
  getLoggedUser: PropTypes.func,
};

class EmailsForm extends React.Component {
  constructor(props) {
    super(props);
    this.selectElements = {};
    this.folderMappersElements = {};
    this.state = {
      selectedDomains: {
        1: undefined,
      },
      emails: {
        1: [],
      },
      loadingEmails: {
        1: true,
      },
    };
  }

  goToNextStep = (e) => {
    const { setFormFieldValue, goToStep, setData, setFormErrors } = this.props;
    e.preventDefault();
    let data = {};
    _.forEach(this.folderMappersElements, (el) => {
      const d = _.omitBy(el.getValues(), (val) => val === false || val === "ignore");
      data = { ...data, ...d };
    });
    setData({
      emailAddressSelected: data,
      domainsSelected: _.valuesIn(this.state.selectedDomains),
    });
    let email_codes = {};

    _.forEach(this.state.emails, (domEmails) => {
      domEmails.forEach((em) => {
        if (data[em.label]) {
          email_codes[em.value] = data[em.label];
        }
      });
    });

    if (Object.keys(email_codes).length === 0) {
      setFormErrors({ onForm: t("errorMsg.delegate.account") });
      return false;
    } else {
      setFormErrors({});
    }

    setFormFieldValue({ email_codes });
    goToStep(4);
  };

  newDomainSelector = () => {
    let lastKey = _.last(Object.keys(this.state.emails));
    this.setState({ emails: { ...this.state.emails, [parseInt(lastKey) + 1]: [] } });
  };

  selectDomainAndLoadEmails = (domainCode, domainSelectId) => {
    this.setState({
      selectedDomains: { ...this.state.selectedDomains, [domainSelectId]: domainCode },
    });

    if (!domainCode) {
      this.setState({
        emails: { ...this.state.emails, [domainSelectId]: [] },
        selectedDomains: { ...this.state.selectedDomains, [domainSelectId]: undefined },
      });

      this.refreshDomainSelects();

      return false;
    }

    this.setState({ loadingEmails: { ...this.state.loadingEmails, [domainSelectId]: true } });

    let client = new QboxmailApi({ useCookie: true });
    return client
      .getArchiveEmailAccounts(domainCode, { per: 10000, postmaster: true })
      .then((data) => {
        let totalEmails = data.resources.map((em) => ({
          value: em.code,
          label: em.email_address,
        }));
        this.setState({
          emails: { ...this.state.emails, [domainSelectId]: totalEmails },
          totalEmails,
          loadingEmails: false,
        });
        this.props.setData({ totalEmails });
      })
      .catch((e) => {
        this.setState({
          emails: { ...this.state.emails, [domainSelectId]: [] },
          loadingEmails: false,
        });
        if (e instanceof Error) throw e;
      });
  };

  render() {
    const { selectedDomains, emails, loadingEmails } = this.state;
    const { formErrors, formData } = this.props;
    const selectedDomainsCodes = _.valuesIn(selectedDomains);

    return (
      <div className="formsPage">
        {this.props.stepper}

        <div className={cx("sectionTitle", "titleFP")}>{t("delegate.add.title.step3")}</div>
        <div className="wrapScrollFP">
          <div className="infoFP">
            <div className="sectionDesc">
              <TranslatedString>delegate.add.desc.step3</TranslatedString>
            </div>
            <Button className="btnDocsFP" docsKey="delegates_add" color="docs" sizeSmall>
              button.docs
            </Button>
          </div>

          <form className="wrapFormsFP" method="post" onSubmit={this.goToNextStep}>
            <div className="formsFP">
              {Object.keys(this.state.emails).map((domainSelectId, idx) => {
                const isLoading = loadingEmails[domainSelectId];
                const hasEmails = emails[domainSelectId] && emails[domainSelectId].length !== 0 && !isLoading;

                return (
                  <div className={cx("inputFull2", s.wrapDomains)} key={domainSelectId}>
                    <DomainSelect
                      ref={(el) => (this.selectElements[domainSelectId] = el)}
                      onChange={(val) => this.selectDomainAndLoadEmails(val.domain, domainSelectId)}
                      value={this.state.selectedDomains[domainSelectId]}
                      disabledIf={(dom) => selectedDomainsCodes.includes(dom.code)}
                      archive
                      customer_code={formData.customer_code}
                      required={false}
                    />

                    {!hasEmails && <div className={s.box}>{t("input.placeholder.domain.select")}</div>}
                    {hasEmails && (
                      <FolderMapper
                        showInboxFirst={false}
                        className={s.folderMapper}
                        folderNames={emails[domainSelectId] ? emails[domainSelectId].map((em) => em.label) : []}
                        ref={(el) => (this.folderMappersElements[domainSelectId] = el)}
                        itemsLabel={t("folderMapper.label.accounts")}
                        allItems={t("folderMapper.label.all.accounts")}
                        destinations={["subject", "full", "ignore"]}
                        destinationLabels={[
                          t("folderMapper.label.subject"),
                          t("folderMapper.label.full"),
                          t("folderMapper.label.ignore"),
                        ]}
                        defaultSelection="ignore"
                        isLoading={isLoading}
                      />
                    )}
                  </div>
                );
              })}

              <Button className="inputFull2" color="outline" type="button" onClick={this.newDomainSelector}>
                button.addDomain
              </Button>
            </div>

            {formErrors.onForm && (
              <div className="warningMsgFP">
                <WarningBanner color="red" msg={formErrors.onForm} />
              </div>
            )}

            <div className="footerFP">
              <Button color="text" type="button" onClick={this.props.backToList}>
                button.cancel
              </Button>
              <Button color="accent" type="submit" disabled={this.state.emails.length === 0}>
                button.continue
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

EmailsForm.contextTypes = ContextTypes;
export default EmailsForm;
